const STORAGE_KEY = 'rr_post_login_path';
const MAX_AGE_MS = 15 * 60 * 1000;

type StoredPath = { path: string; savedAt: number };

const isSafeAppPath = (path: unknown): path is string =>
  typeof path === 'string' && path.startsWith('/') && !path.startsWith('//');

/** Steam-вход уводит со страницы, а BE всегда возвращает на «/»: запоминаем, куда вернуть пользователя. */
export const rememberPostLoginPath = (path: string): void => {
  if (!isSafeAppPath(path)) return;
  try {
    const stored: StoredPath = { path, savedAt: Date.now() };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
  } catch {
    // хранилище недоступно — после входа пользователь окажется на главной
  }
};

export const readPostLoginPath = (now: number = Date.now()): string | null => {
  try {
    const parsed = JSON.parse(sessionStorage.getItem(STORAGE_KEY) ?? 'null') as Partial<StoredPath> | null;
    if (!parsed || !isSafeAppPath(parsed.path) || typeof parsed.savedAt !== 'number') return null;
    return now - parsed.savedAt <= MAX_AGE_MS ? parsed.path : null;
  } catch {
    return null;
  }
};

export const clearPostLoginPath = (): void => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // нечего очищать
  }
};
